import React, { useState } from 'react';
import { Button, Popover, Space, Tag } from 'antd';
import { ICommitter } from '../store/Contributors';

type TProps = {
  commiter: ICommitter;
  handleAttach: () => void;
  handleDetach: () => void;
};

const CommiterActions = ({
  commiter,
  handleAttach,
  handleDetach,
}: TProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover
      trigger="click"
      open={open}
      content={
        <Space direction="vertical">
          <Button onClick={async (e: React.MouseEvent) => {
            e.stopPropagation();
            handleAttach();
            setOpen(false);
          }}>Attach</Button>
          <Button onClick={async (e: React.MouseEvent) => {
            e.stopPropagation();
            handleDetach();
            setOpen(false);
          }}>Detach</Button>
        </Space>
      }
      onOpenChange={setOpen}
    >
      <Tag style={{ cursor: 'pointer' }}><span style={{ color: 'teal' }}>{commiter.author}</span><span style={{ color: 'navy' }}>&lt;{commiter.email}&gt;</span></Tag>
    </Popover>
  );
};

export default CommiterActions;
